/* Optional integrations are isolated from buying controls. */
(() => {
  'use strict';
  const {config, request, log} = window.OudLibrary || {};
  if (!request) return;
  const strings = config.strings || {};
  let adsLoaded = false;
  function safeAdsConsent() { try {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const marketing = privacy.marketingAllowed() === true;
    if (adsLoaded) {
      window.gtag?.('consent', 'update', { ad_storage: marketing ? 'granted' : 'denied', ad_user_data: marketing ? 'granted' : 'denied', ad_personalization: marketing ? 'granted' : 'denied', analytics_storage: privacy.analyticsProcessingAllowed() ? 'granted' : 'denied' });
    } else if (marketing) {
      adsLoaded = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', { ad_storage:'granted', ad_user_data:'granted', ad_personalization:'granted', analytics_storage: privacy.analyticsProcessingAllowed() ? 'granted' : 'denied' });
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16871201121'; document.head.appendChild(script);
      window.gtag('js', new Date()); window.gtag('config', 'AW-16871201121');
    }
    } catch { log('warning','optional_feature_failed',{component:'ads_consent'}); }
  }
  document.addEventListener('visitorConsentCollected', safeAdsConsent);
  document.addEventListener('customerPrivacyApiLoaded', safeAdsConsent);
  window.addEventListener('load', safeAdsConsent, {once:true});
  safeAdsConsent();

  const observed = new WeakMap();
  function initialiseReviews(scope=document) {
    const reviews = scope.querySelector('#ol-reviews');
    if (!reviews || observed.has(reviews)) return;
    const enhanceReviews = () => reviews.querySelectorAll('.jdgm-rev__body').forEach(body => {
      if (body.dataset.olReviewReady) return;
      body.dataset.olReviewReady = 'true';
      const fullText = body.textContent.trim();
      if (fullText.length <= 650) return;
      const excerpt = document.createElement('p');
      excerpt.className = 'ol-review-excerpt';
      excerpt.textContent = fullText.slice(0, 240).replace(/\s+\S*$/, '') + '…';
      const details = document.createElement('details'); details.className = 'ol-review-full';
      const summary = document.createElement('summary'); summary.textContent = strings.readFullReview;
      const content = document.createElement('div');
      content.append(...body.childNodes);
      details.append(summary, content);
      body.append(excerpt, details);
      details.addEventListener('toggle', () => {
        excerpt.hidden = details.open;
        summary.textContent = details.open ? strings.showLessReview : strings.readFullReview;
      });
    });
    enhanceReviews();
    let queued=false;
    const observer=new MutationObserver(()=>{if(!queued){queued=true;queueMicrotask(()=>{queued=false;enhanceReviews();});}});
    observer.observe(reviews,{childList:true,subtree:true});
    observed.set(reviews,observer);

  }
  const recommendationCache=new Map();
  async function loadRecommendations(container) {
    if(container.dataset.olRecommendationsState) return;
    container.dataset.olRecommendationsState='loading';
    try {
      const url=container.dataset.olRecommendations;
      const response=recommendationCache.get(url)||await request(url,{},'recommendations');
      if(typeof response!=='string') throw Error('Invalid recommendation response');
      if(recommendationCache.size>=12) recommendationCache.delete(recommendationCache.keys().next().value);
      recommendationCache.set(url,response);
      if(!container.isConnected) return;
      const doc=new DOMParser().parseFromString(response,'text/html');
      const contents=doc.querySelector('[data-ol-recommendations]');
      if(contents) container.replaceChildren(...contents.childNodes);
    } catch { log('warning','optional_feature_failed',{component:'recommendations'}); }
    finally { container.dataset.olRecommendationsState='complete'; }
  }
  const recommendationsObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){recommendationsObserver.unobserve(entry.target);loadRecommendations(entry.target);}}),{rootMargin:'500px'}):null;
  function initialise(scope=document) {
    try { initialiseReviews(scope); } catch { log('warning','optional_feature_failed',{component:'reviews'}); }
    scope.querySelectorAll('[data-ol-recommendations]').forEach(container=>recommendationsObserver?recommendationsObserver.observe(container):loadRecommendations(container));
  }
  initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  document.addEventListener('shopify:section:unload',event=>{const reviews=event.target.querySelector('#ol-reviews');if(reviews) observed.get(reviews)?.disconnect();event.target.querySelectorAll('[data-ol-recommendations]').forEach(node=>recommendationsObserver?.unobserve(node));});
})();
